export default "__VITE_ASSET__BQf$$k6J__"